module.exports = __webpack_public_path__ + "e487b7cb072550896dde6821d24de2be.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Italic/OpenSans-Italic.eot?v=1.1.0
// module id = 987
// module chunks = 0